export default __webpack_public_path__ + "static/media/partner4.dffa7b37.webp";